export default {
      id: "video-request_loading-usage",
      viewBox: "0 0 28.7 27",
      url: __webpack_public_path__ + "img/icons.svg#video-request_loading",
      toString: function () {
        return this.url;
      }
    }